<template>
  <div class="carStyle">
    <el-form :rules="rules" ref="form" :model="form">
      <div class="halfStyle">
        <div class="title">{{$t('VehicleManagement.baseData')}}</div>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              prop="carId"
              :label="$t('common.carId')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.carId"
                autocomplete="off"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="8"
            ><el-form-item
              prop="plateNum"
              :label="$t('common.plateNum')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.plateNum"
                autocomplete="off"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="8"
            ><el-form-item
              prop="motorNum"
              :label="$t('VehicleManagement.motorNum')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.motorNum"
                autocomplete="off"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              prop="manufactureNum"
              :label="$t('common.manufactureNum')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.manufactureNum"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item
              prop="deliveryTime"
              :label="$t('VehicleManagement.deliveryTime')"
              :label-width="formLabelWidth"
            >
              <el-date-picker
                disabled
                value-format="yyyy-MM-dd"
                type="date"
                placeholder=""
                v-model="form.deliveryTime"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="halfStyle">
        <div class="title">{{$t('VehicleManagement.carTypeData')}}</div>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              prop="brandId"
              :label="$t('common.brand')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.brandId"
                autocomplete="off"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="16"
            ><el-form-item
              prop="brandTypeId"
              :label="$t('common.model')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.brandTypeId"
                autocomplete="off"
                class="inputStyle"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              prop="type"
              :label="$t('VehicleManagement.carType')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.type"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item
              prop="capacity"
              :label="$t('VehicleManagement.capacity')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.capacity"
                autocomplete="off"
                class="inputStyle"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              prop="remarks"
              :label="$t('common.remark')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.remarks"
                autocomplete="off"
                class="remarkStyle"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ["bindCar"],
  data() {
    return {
      rules: {},
      form: {
        carId: "",
        plateNum: "",
        motorNum: "",
        manufactureNum: "",
        deliveryTime: "",
        brandId: "",
        brandTypeId: "",
        type: "",
        capacity: "",
        remarks: "",
      },
      formLabelWidth: "70px",
      carId: "",
    };
  },
  created() {
    
  },
  methods: {
    getSelectOneCar() {
      let param = {
        carId: this.bindCar,
      };
      this.$store
        .dispatch("VehicleStatus/GET_SELECTONECAR", param)
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              this.form = {
                carId: res.data.data.carId,
                plateNum: res.data.data.plateNum,
                motorNum: res.data.data.motorNum,
                manufactureNum: res.data.data.manufactureNum,
                deliveryTime: res.data.data.deliveryTime,
                brandId: res.data.data.brandName,
                brandTypeId: res.data.data.brandTypeName,
                type: res.data.data.typeName,
                capacity: res.data.data.capacity,
                remarks: res.data.data.remarks,
              };
            }
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>